module.exports = __webpack_public_path__ + "static/images/check-circle-green.49dd560ed8538047e07cad00e4b8f15e.svg";